import type { CardTokens, RadiusScale, SpacingScale } from '@/theme/types'

export const createCardTokens = (
  radius: RadiusScale,
  spacing: SpacingScale,
  elevationLevel: number,
): CardTokens => ({
  padding: spacing[4],
  borderRadius: radius.lg,
  elevationLevel,
})

